import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../../../../shared/models/user.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() breadcrumbItems: any[] = [];

  @Input() currentUser: User | null = null;

  /** SSO's allow_switch_account for the account that signed in (SUPERADMIN or CHANGE_USER). */
  @Input() canSwitchAccount = false;
  @Input() isSwitchedAccount = false;
  @Input() isSwitchingAccount = false;
  @Input() isRestoringAccount = false;
  @Input() realAdminName: string | null = null;

  @Output() toggleSidebar = new EventEmitter<void>();

  @Output() academicYearChanged = new EventEmitter<any>();

  @Output() openAccount = new EventEmitter<void>();
  @Output() switchAccount = new EventEmitter<void>();
  @Output() restoreAccount = new EventEmitter<void>();
  @Output() logOut = new EventEmitter<void>();

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }

  onChangeAcademicYear(event: any): void {
    this.academicYearChanged.emit(event);
  }

  onOpenAccount(): void {
    this.openAccount.emit();
  }

  onSwitchAccount(): void {
    this.switchAccount.emit();
  }

  onRestoreAccount(): void {
    this.restoreAccount.emit();
  }

  onLogOut(): void {
    this.logOut.emit();
  }
}
